/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BackupFileDto } from '../models/backup-file-dto';
import { backupLocalizations } from '../fn/localization/backup-localizations';
import { BackupLocalizations$Params } from '../fn/localization/backup-localizations';
import { getLocalizations } from '../fn/localization/get-localizations';
import { GetLocalizations$Params } from '../fn/localization/get-localizations';
import { restoreLocalizationFile } from '../fn/localization/restore-localization-file';
import { RestoreLocalizationFile$Params } from '../fn/localization/restore-localization-file';
import { restoreLocalizations } from '../fn/localization/restore-localizations';
import { RestoreLocalizations$Params } from '../fn/localization/restore-localizations';

@Injectable({ providedIn: 'root' })
export class GeneratedLocalizationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `backupLocalizations()` */
  static readonly BackupLocalizationsPath = '/api/localizations/{type}/backup';

  /**
   * Backups custom localizations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `backupLocalizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  backupLocalizations$Response(params: BackupLocalizations$Params, context?: HttpContext): Observable<StrictHttpResponse<BackupFileDto>> {
    return backupLocalizations(this.http, this.rootUrl, params, context);
  }

  /**
   * Backups custom localizations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `backupLocalizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  backupLocalizations(params: BackupLocalizations$Params, context?: HttpContext): Observable<BackupFileDto> {
    return this.backupLocalizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<BackupFileDto>): BackupFileDto => r.body)
    );
  }

  /** Path part for operation `restoreLocalizations()` */
  static readonly RestoreLocalizationsPath = '/api/localizations/{type}/backup';

  /**
   * Restores a backup of custom localizations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restoreLocalizations()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  restoreLocalizations$Response(params: RestoreLocalizations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return restoreLocalizations(this.http, this.rootUrl, params, context);
  }

  /**
   * Restores a backup of custom localizations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restoreLocalizations$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  restoreLocalizations(params: RestoreLocalizations$Params, context?: HttpContext): Observable<void> {
    return this.restoreLocalizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `restoreLocalizationFile()` */
  static readonly RestoreLocalizationFilePath = '/api/localizations/{type}/backup/file';

  /**
   * Restores a backup-file of custom localizations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restoreLocalizationFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  restoreLocalizationFile$Response(params: RestoreLocalizationFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return restoreLocalizationFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Restores a backup-file of custom localizations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restoreLocalizationFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  restoreLocalizationFile(params: RestoreLocalizationFile$Params, context?: HttpContext): Observable<void> {
    return this.restoreLocalizationFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getLocalizations()` */
  static readonly GetLocalizationsPath = '/api/localizations/{type}';

  /**
   * Gets the custom localizations by their specified type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLocalizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocalizations$Response(params: GetLocalizations$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: any;
}>> {
    return getLocalizations(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the custom localizations by their specified type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLocalizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocalizations(params: GetLocalizations$Params, context?: HttpContext): Observable<{
[key: string]: any;
}> {
    return this.getLocalizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: any;
}>): {
[key: string]: any;
} => r.body)
    );
  }

}
